import { ReviewList } from "@components"
import * as React from "react"
import { PopupButton } from "react-calendly"

export const ResourceClientReview = () => {
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="container mx-auto mt-10 pt-10">
        <div className="pt-10">
          <div className="text-center">
            <p className="text-[#7B68EC]">Respected Words</p>
            <p className="lg:text-5xl text-nowrap text-[10px] text-black font-semibold">
              What our client’s say about <br />
              our resources?
            </p>
          </div>
        </div>
        {/* <Review
          title="KINGDOM DOMAIN COLLEGE"
          profileTitle="Danielle Jenkins"
          profileDescription="Super Model"
          description="“ Trust Haseeb and his team with our branding and website - they did not disappoint.”"
          isPicture
          stars={5}
          isLoveVisualFolio
        />
        <Review
          title="KINGDOM DOMAIN COLLEGE"
          profileTitle="Danielle Jenkins"
          profileDescription="Super Model"
          description="“ Trust Haseeb and his team with our branding and website - they did not disappoint.”"
          isPicture
          stars={5}
          isReverse
        /> */}
        <ReviewList />
      </div>
      <div
        className={`mt-16 py-16  ${theme == "glassy" ? "mb-10 bg-resource-footer w-[80%] mx-auto rounded-2xl" : theme === "light" ? "result-bg" : theme === "dark" ? "result-bg" : "mb-10 bg-resource-footer w-[80%] mx-auto rounded-2xl"}`}
      >
        <div className="text-center">
          <p className="lg:text-4xl text-nowrap text-[10px] text-black font-semibold">
            Get results you’ll want <br /> to take credit for
          </p>
          <div className="flex justify-center pt-8">
            {rootElement && (
              <PopupButton
                className="px-5 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-[7px] whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text="Hire A Workforce"
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
